module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "erco-back-to-top-button-fade"
    }
  }, [(_vm.buttonIsVisible) ? _c('div', {
    staticClass: "erco-back-to-top-button"
  }, [_c('b-button', {
    staticClass: "btn",
    attrs: {
      "size": "sm",
      "title": "Nach oben"
    },
    on: {
      "click": _vm.handleBackToTopClick
    }
  }, [_c('span', {
    staticClass: "chevron"
  })])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37b6c8e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/ErcoBackToTopButton.vue
// module id = 615
// module chunks = 0